// @ts-nocheck
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import {
    Activity,
    Zap,
    Heart,
    Image as ImageIcon,
    Brain,
    Shield,
    ArrowRight,
    Download,
    Sparkles,
    Timer,
    Mountain,
    CheckCircle2,
} from "lucide-react";

// PaceVibe brand colors (matching the app's globals.css)
const colors = {
    bgTop: "#0F1115",
    bgBottom: "#06080d",
    primary: "#DFFF00",
    primaryDim: "#a8c200",
    secondary: "#FF5722",
    cardBg: "rgba(26, 29, 35, 0.6)",
    cardBorder: "rgba(255, 255, 255, 0.08)",
    text: "#F8FAFC",
    textMuted: "#94a3b8",
};

// Auto-detect browser language: Greek browsers get Greek, everyone else gets English
const detectInitialLang = () => {
    if (typeof window === "undefined" || !navigator) return "en";
    const browserLang = (navigator.language || "").toLowerCase();
    return browserLang.startsWith("el") ? "el" : "en";
};

// i18n dictionary
const dict = {
    el: {
        pageTitle: "PaceVibe — Race Strategy & Fueling for Runners | Orion Intelligence",
        backHome: "← Πίσω στην αρχική",
        appsForAthletes: "Apps for Athletes",
        // Hero
        heroBadge: "For Runners Who Race",
        heroSubA: "Pro-grade race strategy",
        heroSubB: "& fueling.",
        heroDesc: "Pace strategies, hour-by-hour fueling με συγκεκριμένα brands gels, heart-rate zones, και ένα ",
        heroDescBold: "lock-screen wallpaper",
        heroDescTail: " με τα splits σου. Φτιαγμένο για δρομείς που θέλουν να βγάλουν την καλύτερη τους μέρα.",
        getItOnPlay: "Get it on Google Play",
        privacyPolicy: "Privacy Policy",
        badgeLocalFirst: "Local-first",
        badgeNoTracking: "No tracking",
        badgeGDPR: "GDPR ready",
        // Phone mockup
        raceDayReady: "Race Day Ready",
        target: "TARGET",
        splits: "SPLITS",
        fuelingPlan: "FUELING PLAN",
        negSplits: "Negative splits · 4:37/km avg",
        // Features
        featuresTitle: "Έξι λόγοι για να το δοκιμάσεις",
        featuresSubtitle: "Σχεδιασμένο από δρομέα, για δρομείς. Όλα όσα χρειάζεσαι για να βγάλεις τη μέρα του αγώνα.",
        feat1Title: "Pace Strategies",
        feat1Text: "Even, negative ή custom splits. Υπολογίζει τον ακριβή ρυθμό σου για κάθε χιλιόμετρο, ώστε να φτάσεις τον στόχο χωρίς να καείς νωρίς.",
        feat2Title: "Hour-by-Hour Fueling",
        feat2Text: "Brand-specific gel plan (SiS, Maurten, GU κ.ά.) με ακριβή timing υδατανθράκων ανά ώρα — ότι χρειάζεσαι για μαραθώνιο και ημιμαραθώνιο.",
        feat3Title: "Heart Rate Zones",
        feat3Text: "Karvonen-based ζώνες προσαρμοσμένες στην ηλικία και τους καρδιακούς ηρεμίας σου. Ξέρεις πάντα σε ποια ζώνη πρέπει να είσαι.",
        feat4Title: "GPX Race Mode",
        feat4Text: "Ανέβασε το αρχείο της διαδρομής. Το PaceVibe προσαρμόζει τα splits με βάση το υψομετρικό προφίλ — ανηφόρες, κατηφόρες, καθετιώσεις.",
        feat5Title: "Lock-Screen Wallpaper",
        feat5Text: "Δημιουργεί custom wallpaper με τα splits και το fueling plan σου, για να τα έχεις πάντα διαθέσιμα στο κινητό κατά τη διάρκεια του αγώνα.",
        feat6Title: "AI Coach",
        feat6Text: "Εξατομικευμένη συμβουλή με βάση τις συνθήκες (καιρός, υγρασία, υψόμετρο) και το προφίλ σου. Powered by Claude AI.",
        // Pricing
        pricingTitle1: "Δωρεάν για να το γνωρίσεις.",
        pricingTitle2: "για να ξεχωρίσεις.",
        pricingSubtitle: "Ξεκίνα δωρεάν με τα βασικά. Κάνε upgrade όταν θέλεις τα εργαλεία που βάζεις σε διαφορά.",
        forever: "Forever",
        freePriceLabel: "Δωρεάν χωρίς όριο χρόνου",
        perMonth: "/μήνα",
        proPriceSubA: "ή ",
        proPriceSubBold: "€29.99/χρόνο",
        proPriceSubTail: " (εξοικονόμηση 37%)",
        free1: "Pace calculator (Even / Negative)",
        free2: "Lock-Screen Wallpaper Generator",
        free3: "Basic splits & target time",
        free4: "Athens Marathon profile",
        pro1: "Brand-specific Fueling Strategist",
        pro2: "Heart Rate Zones (Karvonen)",
        pro3: "GAP (Grade-Adjusted Pace)",
        pro4: "AI Coach (Claude-powered)",
        pro5: "CSV Export των splits",
        pro6: "Race library & saved profiles",
        // CTA
        ctaBadge: "Ready to Race?",
        ctaTitle1: "Σταμάτα να μαντεύεις τον ρυθμό σου.",
        ctaTitle2: "Άρχισε να τον σχεδιάζεις.",
        ctaDesc: "Διαθέσιμο τώρα στο Google Play. Δοκίμασε δωρεάν, χωρίς εγγραφή, χωρίς δεσμεύσεις.",
        contactBtn: "Επικοινωνία",
        // Footer
        footerHome: "Αρχική",
        footerPrivacy: "Πολιτική Απορρήτου",
        footerTerms: "Όροι Χρήσης",
    },
    en: {
        pageTitle: "PaceVibe — Race Strategy & Fueling for Runners | Orion Intelligence",
        backHome: "← Back to home",
        appsForAthletes: "Apps for Athletes",
        // Hero
        heroBadge: "For Runners Who Race",
        heroSubA: "Pro-grade race strategy",
        heroSubB: "& fueling.",
        heroDesc: "Pace strategies, hour-by-hour fueling with brand-specific gels, heart-rate zones, and a ",
        heroDescBold: "lock-screen wallpaper",
        heroDescTail: " with your splits. Built for runners who want to nail race day.",
        getItOnPlay: "Get it on Google Play",
        privacyPolicy: "Privacy Policy",
        badgeLocalFirst: "Local-first",
        badgeNoTracking: "No tracking",
        badgeGDPR: "GDPR ready",
        // Phone mockup
        raceDayReady: "Race Day Ready",
        target: "TARGET",
        splits: "SPLITS",
        fuelingPlan: "FUELING PLAN",
        negSplits: "Negative splits · 4:37/km avg",
        // Features
        featuresTitle: "Six reasons to try it",
        featuresSubtitle: "Designed by a runner, for runners. Everything you need to nail race day.",
        feat1Title: "Pace Strategies",
        feat1Text: "Even, negative or custom splits. Calculates your exact pace per kilometre so you hit your target without burning out early.",
        feat2Title: "Hour-by-Hour Fueling",
        feat2Text: "Brand-specific gel plan (SiS, Maurten, GU and more) with precise carb timing per hour — exactly what you need for marathon and half-marathon.",
        feat3Title: "Heart Rate Zones",
        feat3Text: "Karvonen-based zones adjusted to your age and resting heart rate. You always know which zone you should be in.",
        feat4Title: "GPX Race Mode",
        feat4Text: "Upload your course file. PaceVibe adjusts splits based on the elevation profile — climbs, descents, gradients.",
        feat5Title: "Lock-Screen Wallpaper",
        feat5Text: "Creates a custom wallpaper with your splits and fueling plan, so you always have them on your phone during the race.",
        feat6Title: "AI Coach",
        feat6Text: "Personalised advice based on conditions (weather, humidity, altitude) and your profile. Powered by Claude AI.",
        // Pricing
        pricingTitle1: "Free to get to know it.",
        pricingTitle2: "to stand out.",
        pricingSubtitle: "Start free with the basics. Upgrade when you want the tools that make a difference.",
        forever: "Forever",
        freePriceLabel: "Free, no time limit",
        perMonth: "/month",
        proPriceSubA: "or ",
        proPriceSubBold: "€29.99/year",
        proPriceSubTail: " (save 37%)",
        free1: "Pace calculator (Even / Negative)",
        free2: "Lock-Screen Wallpaper Generator",
        free3: "Basic splits & target time",
        free4: "Athens Marathon profile",
        pro1: "Brand-specific Fueling Strategist",
        pro2: "Heart Rate Zones (Karvonen)",
        pro3: "GAP (Grade-Adjusted Pace)",
        pro4: "AI Coach (Claude-powered)",
        pro5: "CSV Splits Export",
        pro6: "Race library & saved profiles",
        // CTA
        ctaBadge: "Ready to Race?",
        ctaTitle1: "Stop guessing your pace.",
        ctaTitle2: "Start planning it.",
        ctaDesc: "Available now on Google Play. Try it free, no signup, no commitments.",
        contactBtn: "Contact",
        // Footer
        footerHome: "Home",
        footerPrivacy: "Privacy Policy",
        footerTerms: "Terms",
    },
};

export default function PaceVibePage() {
    const navigate = useNavigate();
    const [lang, setLang] = useState(detectInitialLang);
    const t = dict[lang];

    useEffect(() => {
        document.title = t.pageTitle;
        // Always start at top when entering this page
        window.scrollTo(0, 0);
        return () => { document.title = "Orion Intelligence"; };
    }, [t.pageTitle]);

    const goToContact = (e) => {
        e.preventDefault();
        navigate("/#contact");
    };

    const features = [
        { icon: Timer, title: t.feat1Title, text: t.feat1Text },
        { icon: Zap, title: t.feat2Title, text: t.feat2Text },
        { icon: Heart, title: t.feat3Title, text: t.feat3Text },
        { icon: Mountain, title: t.feat4Title, text: t.feat4Text },
        { icon: ImageIcon, title: t.feat5Title, text: t.feat5Text },
        { icon: Brain, title: t.feat6Title, text: t.feat6Text },
    ];

    const proFeatures = [t.pro1, t.pro2, t.pro3, t.pro4, t.pro5, t.pro6];
    const freeFeatures = [t.free1, t.free2, t.free3, t.free4];

    return (
        <div
            className="min-h-screen flex flex-col relative overflow-hidden"
            style={{
                color: colors.text,
                background: `radial-gradient(ellipse at 20% 0%, rgba(223, 255, 0, 0.12), transparent 50%),
                             radial-gradient(ellipse at 80% 100%, rgba(255, 87, 34, 0.08), transparent 40%),
                             linear-gradient(170deg, ${colors.bgTop}, ${colors.bgBottom})`,
            }}
        >
            {/* Nav */}
            <div className="max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 flex items-center justify-between relative z-10">
                <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    className="flex items-center gap-3"
                >
                    <img
                        src="/assets/orion-logo-800.png"
                        alt="Orion logo"
                        className="w-10 h-10 rounded-xl"
                        style={{ boxShadow: `0 0 20px rgba(223, 255, 0, 0.25)` }}
                    />
                    <div className="text-left leading-tight">
                        <div className="text-lg font-bold tracking-wide" style={{ color: colors.primary }}>
                            Orion Intelligence
                        </div>
                        <div className="text-xs" style={{ color: colors.textMuted }}>
                            {t.appsForAthletes}
                        </div>
                    </div>
                </motion.div>

                <div className="flex items-center gap-4">
                    {/* Language Toggle */}
                    <div className="flex items-center rounded-full border overflow-hidden text-xs font-bold"
                        style={{ borderColor: colors.cardBorder, background: "rgba(255,255,255,0.04)" }}>
                        <button
                            onClick={() => setLang("el")}
                            className="px-3 py-1.5 transition-all"
                            style={{
                                background: lang === "el" ? colors.primary : "transparent",
                                color: lang === "el" ? "#0F1115" : colors.textMuted,
                            }}
                            aria-label="Ελληνικά"
                        >
                            ΕΛ
                        </button>
                        <button
                            onClick={() => setLang("en")}
                            className="px-3 py-1.5 transition-all"
                            style={{
                                background: lang === "en" ? colors.primary : "transparent",
                                color: lang === "en" ? "#0F1115" : colors.textMuted,
                            }}
                            aria-label="English"
                        >
                            EN
                        </button>
                    </div>

                    <Link to="/" className="hidden sm:inline text-sm font-medium hover:text-white transition-colors"
                        style={{ color: colors.textMuted }}>
                        {t.backHome}
                    </Link>
                </div>
            </div>

            <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 flex-grow relative z-10">

                {/* === HERO === */}
                <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                    >
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border mb-6"
                            style={{
                                borderColor: colors.primary,
                                background: "rgba(223, 255, 0, 0.06)",
                                color: colors.primary
                            }}>
                            <Sparkles size={16} />
                            <span className="text-xs font-bold uppercase tracking-widest">{t.heroBadge}</span>
                        </div>

                        <h1 className="text-5xl md:text-6xl font-black mb-6 leading-[0.95] tracking-tighter italic uppercase">
                            Pace<span style={{ color: colors.primary }}>Vibe</span>
                            <br />
                            <span className="text-2xl md:text-3xl font-black tracking-tight normal-case not-italic block mt-3" style={{ color: colors.text }}>
                                {t.heroSubA}<br />
                                <span style={{ color: colors.secondary }}>{t.heroSubB}</span>
                            </span>
                        </h1>

                        <p className="text-lg leading-relaxed mb-8" style={{ color: colors.textMuted }}>
                            {t.heroDesc}
                            <strong style={{ color: colors.primary }}>{t.heroDescBold}</strong>
                            {t.heroDescTail}
                        </p>

                        <div className="flex flex-wrap gap-4 mb-8">
                            <a
                                href="https://play.google.com/store/apps/details?id=com.orionintelligence.pacevibe"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-3 px-7 py-4 rounded-2xl font-bold transition-all shadow-lg group"
                                style={{
                                    background: colors.primary,
                                    color: "#0F1115",
                                    boxShadow: `0 10px 40px rgba(223, 255, 0, 0.25)`
                                }}
                            >
                                <Download size={20} />
                                <span>{t.getItOnPlay}</span>
                                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                            </a>
                            <Link
                                to="/pacevibe/privacy"
                                className="inline-flex items-center gap-2 px-5 py-4 rounded-2xl border font-medium hover:bg-white/5 transition-colors"
                                style={{ borderColor: colors.cardBorder, color: colors.textMuted }}
                            >
                                <Shield size={16} />
                                {t.privacyPolicy}
                            </Link>
                        </div>

                        <div className="flex flex-wrap items-center gap-3 text-xs">
                            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border"
                                style={{ borderColor: colors.cardBorder, background: "rgba(255,255,255,0.03)", color: colors.textMuted }}>
                                <CheckCircle2 size={12} style={{ color: colors.primary }} />
                                {t.badgeLocalFirst}
                            </span>
                            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border"
                                style={{ borderColor: colors.cardBorder, background: "rgba(255,255,255,0.03)", color: colors.textMuted }}>
                                <CheckCircle2 size={12} style={{ color: colors.primary }} />
                                {t.badgeNoTracking}
                            </span>
                            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border"
                                style={{ borderColor: colors.cardBorder, background: "rgba(255,255,255,0.03)", color: colors.textMuted }}>
                                <CheckCircle2 size={12} style={{ color: colors.primary }} />
                                {t.badgeGDPR}
                            </span>
                        </div>
                    </motion.div>

                    {/* Phone Mockup */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.85 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.2 }}
                        className="relative flex justify-center"
                    >
                        <div className="absolute inset-0 blur-[120px] rounded-full"
                            style={{ background: `${colors.primary}20` }} />

                        <div className="relative w-[280px] h-[560px] rounded-[3rem] border-[10px] shadow-2xl"
                            style={{
                                background: colors.bgTop,
                                borderColor: "#1f2937",
                                boxShadow: `0 30px 80px rgba(0,0,0,0.6), 0 0 60px rgba(223, 255, 0, 0.15)`
                            }}>
                            <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-6 rounded-full"
                                style={{ background: "#0a0c12" }} />

                            <div className="pt-12 px-6">
                                <div className="flex items-center gap-3 mb-6">
                                    <img
                                        src="/assets/pacevibe-logo.jpg"
                                        alt="PaceVibe"
                                        className="w-12 h-12 rounded-2xl object-cover shadow-lg"
                                    />
                                    <div>
                                        <div className="text-xs font-black uppercase tracking-widest" style={{ color: colors.primary }}>
                                            PaceVibe
                                        </div>
                                        <div className="text-[10px]" style={{ color: colors.textMuted }}>
                                            {t.raceDayReady}
                                        </div>
                                    </div>
                                </div>

                                <div className="rounded-2xl p-4 mb-3 border"
                                    style={{ background: "rgba(223, 255, 0, 0.04)", borderColor: "rgba(223, 255, 0, 0.2)" }}>
                                    <div className="text-[9px] font-black uppercase tracking-widest mb-1"
                                        style={{ color: colors.primary }}>
                                        {t.target}
                                    </div>
                                    <div className="text-2xl font-black tracking-tight" style={{ color: colors.text }}>
                                        Marathon · 3:15:00
                                    </div>
                                    <div className="text-[10px] mt-1" style={{ color: colors.textMuted }}>
                                        {t.negSplits}
                                    </div>
                                </div>

                                <div className="rounded-2xl p-4 border space-y-2"
                                    style={{ background: "rgba(255,255,255,0.02)", borderColor: colors.cardBorder }}>
                                    <div className="text-[9px] font-black uppercase tracking-widest"
                                        style={{ color: colors.textMuted }}>
                                        {t.splits}
                                    </div>
                                    {[
                                        { km: "5km", pace: "4:42", c: colors.primary },
                                        { km: "10km", pace: "4:40", c: colors.primary },
                                        { km: "21km", pace: "4:37", c: colors.text },
                                        { km: "32km", pace: "4:35", c: colors.text },
                                        { km: "42km", pace: "4:30", c: colors.secondary },
                                    ].map((s, i) => (
                                        <div key={i} className="flex justify-between items-center text-xs">
                                            <span style={{ color: colors.textMuted }}>{s.km}</span>
                                            <span className="font-mono font-bold" style={{ color: s.c }}>
                                                {s.pace}/km
                                            </span>
                                        </div>
                                    ))}
                                </div>

                                <div className="mt-3 rounded-2xl p-4 border"
                                    style={{
                                        background: "rgba(255, 87, 34, 0.06)",
                                        borderColor: "rgba(255, 87, 34, 0.25)"
                                    }}>
                                    <div className="text-[9px] font-black uppercase tracking-widest mb-2"
                                        style={{ color: colors.secondary }}>
                                        ⚡ {t.fuelingPlan}
                                    </div>
                                    <div className="space-y-1.5 text-[10px]" style={{ color: colors.textMuted }}>
                                        <div className="flex justify-between">
                                            <span>0:30 — SiS Beta Fuel</span>
                                            <span style={{ color: colors.text }}>40g</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span>1:00 — Maurten 100</span>
                                            <span style={{ color: colors.text }}>25g</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span>1:45 — SiS Go</span>
                                            <span style={{ color: colors.text }}>22g</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* === FEATURES GRID === */}
                <div className="mb-24">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="text-center mb-12"
                    >
                        <h2 className="text-3xl md:text-4xl font-black mb-4">
                            {t.featuresTitle}
                        </h2>
                        <p className="text-base md:text-lg max-w-2xl mx-auto" style={{ color: colors.textMuted }}>
                            {t.featuresSubtitle}
                        </p>
                    </motion.div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {features.map((f, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: i * 0.05 }}
                                whileHover={{ y: -6 }}
                                className="p-7 rounded-2xl border transition-all duration-300 group"
                                style={{ background: colors.cardBg, borderColor: colors.cardBorder }}
                            >
                                <div className="p-3 rounded-xl bg-white/5 w-fit mb-5 transition-colors group-hover:bg-white/10">
                                    <f.icon size={26} style={{ color: colors.primary }} />
                                </div>
                                <h3 className="text-lg font-bold mb-2 tracking-tight">{f.title}</h3>
                                <p className="text-sm leading-relaxed" style={{ color: colors.textMuted }}>
                                    {f.text}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* === FREE vs PRO === */}
                <div className="mb-24">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="text-center mb-12"
                    >
                        <h2 className="text-3xl md:text-4xl font-black mb-4">
                            {t.pricingTitle1} <span style={{ color: colors.primary }}>Pro</span> {t.pricingTitle2}
                        </h2>
                        <p className="text-base max-w-2xl mx-auto" style={{ color: colors.textMuted }}>
                            {t.pricingSubtitle}
                        </p>
                    </motion.div>

                    <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
                        {/* FREE */}
                        <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            className="p-8 rounded-3xl border"
                            style={{ background: colors.cardBg, borderColor: colors.cardBorder }}
                        >
                            <div className="flex items-center justify-between mb-6">
                                <h3 className="text-2xl font-black tracking-tight">Free</h3>
                                <span className="text-xs font-bold px-3 py-1 rounded-full"
                                    style={{ background: "rgba(255,255,255,0.06)", color: colors.textMuted }}>
                                    {t.forever}
                                </span>
                            </div>
                            <div className="text-4xl font-black mb-1" style={{ color: colors.text }}>€0</div>
                            <p className="text-xs mb-6" style={{ color: colors.textMuted }}>
                                {t.freePriceLabel}
                            </p>
                            <ul className="space-y-3">
                                {freeFeatures.map((f, i) => (
                                    <li key={i} className="flex items-center gap-3 text-sm" style={{ color: colors.text }}>
                                        <CheckCircle2 size={16} style={{ color: colors.primary }} />
                                        {f}
                                    </li>
                                ))}
                            </ul>
                        </motion.div>

                        {/* PRO */}
                        <motion.div
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            className="p-8 rounded-3xl border-2 relative overflow-hidden"
                            style={{
                                background: `linear-gradient(135deg, rgba(223, 255, 0, 0.08), rgba(255, 87, 34, 0.04))`,
                                borderColor: colors.primary,
                                boxShadow: `0 20px 60px rgba(223, 255, 0, 0.12)`
                            }}
                        >
                            <div className="absolute top-4 right-4">
                                <span className="text-xs font-black px-3 py-1 rounded-full uppercase tracking-widest"
                                    style={{ background: colors.primary, color: "#0F1115" }}>
                                    ⚡ Pro
                                </span>
                            </div>
                            <div className="flex items-center gap-3 mb-6">
                                <h3 className="text-2xl font-black tracking-tight">PaceVibe Pro</h3>
                            </div>
                            <div className="flex items-baseline gap-2 mb-1">
                                <span className="text-4xl font-black" style={{ color: colors.text }}>€3.99</span>
                                <span className="text-sm" style={{ color: colors.textMuted }}>{t.perMonth}</span>
                            </div>
                            <p className="text-xs mb-6" style={{ color: colors.textMuted }}>
                                {t.proPriceSubA}
                                <strong style={{ color: colors.primary }}>{t.proPriceSubBold}</strong>
                                {t.proPriceSubTail}
                            </p>
                            <ul className="space-y-3">
                                {proFeatures.map((f, i) => (
                                    <li key={i} className="flex items-center gap-3 text-sm" style={{ color: colors.text }}>
                                        <CheckCircle2 size={16} style={{ color: colors.primary }} />
                                        {f}
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    </div>
                </div>

                {/* === FINAL CTA === */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="p-12 md:p-16 rounded-[3rem] border text-center relative overflow-hidden mb-12"
                    style={{
                        background: `radial-gradient(circle at 50% 0%, rgba(223, 255, 0, 0.1), transparent 60%), rgba(255,255,255,0.02)`,
                        borderColor: colors.cardBorder,
                    }}
                >
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 blur-[100px] rounded-full"
                        style={{ background: `${colors.primary}15` }} />

                    <div className="relative z-10">
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border mb-6"
                            style={{
                                borderColor: colors.primary,
                                background: "rgba(223, 255, 0, 0.06)",
                                color: colors.primary
                            }}>
                            <Activity size={14} />
                            <span className="text-xs font-bold uppercase tracking-widest">{t.ctaBadge}</span>
                        </div>

                        <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight">
                            {t.ctaTitle1}
                            <br />
                            <span style={{ color: colors.primary }}>{t.ctaTitle2}</span>
                        </h2>

                        <p className="text-base md:text-lg max-w-2xl mx-auto mb-10" style={{ color: colors.textMuted }}>
                            {t.ctaDesc}
                        </p>

                        <div className="flex flex-wrap justify-center gap-4">
                            <a
                                href="https://play.google.com/store/apps/details?id=com.orionintelligence.pacevibe"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-3 px-8 py-4 rounded-2xl font-bold transition-all shadow-xl group"
                                style={{
                                    background: colors.primary,
                                    color: "#0F1115",
                                    boxShadow: `0 15px 50px rgba(223, 255, 0, 0.3)`
                                }}
                            >
                                <Download size={20} />
                                <span>{t.getItOnPlay}</span>
                                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                            </a>
                            <button
                                onClick={goToContact}
                                className="inline-flex items-center gap-2 px-6 py-4 rounded-2xl font-bold border hover:bg-white/5 transition-colors cursor-pointer"
                                style={{ borderColor: colors.cardBorder, color: colors.text, background: "transparent" }}
                            >
                                {t.contactBtn}
                            </button>
                        </div>
                    </div>
                </motion.div>

            </main>

            <footer className="py-12 border-t border-white/5 mt-8 opacity-70 text-center relative z-10">
                <p className="text-xs uppercase tracking-widest mb-2" style={{ color: colors.textMuted }}>
                    © {new Date().getFullYear()} Orion Intelligence • PaceVibe
                </p>
                <div className="flex justify-center gap-6 text-xs">
                    <Link to="/" className="hover:text-white transition-colors" style={{ color: colors.textMuted }}>
                        {t.footerHome}
                    </Link>
                    <Link to="/pacevibe/privacy" className="hover:text-white transition-colors" style={{ color: colors.textMuted }}>
                        {t.footerPrivacy}
                    </Link>
                    <Link to="/terms" className="hover:text-white transition-colors" style={{ color: colors.textMuted }}>
                        {t.footerTerms}
                    </Link>
                </div>
            </footer>
        </div>
    );
}
